import React, { useRef } from 'react';
import classnames from 'classnames';
import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';
import {
  useAnalyticsPageView,
  useSegmentAnalytics,
} from '@nerdwallet/seo-analytics';

import registerLink from '~/client/lib/register-link';

interface Props {
  children: React.ReactNode;
  className?: string;
  driverLocation?: string;
  flow?: string;
  impressionPayload?: object;
  onClick?: () => void;
}

const AuthModal: React.FC<Props> = ({
  children,
  className = '',
  driverLocation = '',
  flow = 'credit-score',
  impressionPayload = {},
  onClick = () => {},
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { pageName, pageViewId } = useAnalyticsPageView();
  const { analytics, deviceId } = useSegmentAnalytics();

  const handleClick = async (e, impressionId) => {
    if (typeof window !== 'undefined') {
      e.preventDefault();
      e.stopPropagation();
      onClick();
      window.location.href = registerLink(flow, {
        element: 'ad_unit',
        flow,
        location: driverLocation,
        anonymousUserId:
          (await analytics?.segmentInstance?.user()).anonymousId() ?? '',
        deviceId,
        impressionId,
        pageName,
        pageViewId,
      }).url;
    }
  };

  return (
    <Impression {...impressionPayload}>
      <ImpressionContext.Consumer>
        {({ impressionId }) => (
          <div
            ref={ref}
            onClick={(e) => handleClick(e, impressionId)}
            className={classnames('auth-modal', className)}
          >
            {children}
          </div>
        )}
      </ImpressionContext.Consumer>
    </Impression>
  );
};

export default AuthModal;
